import { useEffect, useState } from 'react';

/**
 * This hooks unifies the same behaviour of showing
 * the header menu (hamburger menu) on different platforms
 */
const mediaQueryList = window.matchMedia('(max-width: 1024px)');

export const useMenuCollapse = (navItems: number) => {
  const [collapsed, setCollapsed] = useState(mediaQueryList.matches || navItems > 4);

  useEffect(() => {
    const update = () => setCollapsed(mediaQueryList.matches || navItems > 4);
    mediaQueryList.addEventListener('change', update);
    update();

    return () => mediaQueryList.removeEventListener('change', update);
  }, [navItems]);

  return collapsed;
};
